import type { TrackingArgs } from '../../helpers/hooks/useTracking';

export const TRACKING_ARGS_PAGE_WHOISWATCHING: TrackingArgs = {
  tracking: { dataLayer: { page_name: 'Profile selection' } },
};
